import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { useSelection } from "../SelectionContext";
import { invalidateBusinessResources } from "../utils/businessResourceFreshness";

// Capture the authorising context before the write; a later selection cannot invalidate a different tenant.
export default function useBusinessMutationInvalidation(mutation: string) {
  const client = useQueryClient();
  const { user } = useAuth();
  const { selectedCompany, selectedWarehouse } = useSelection();
  const userId = user?.id;
  const companyId = (selectedCompany as any)?.id ?? selectedCompany;
  const warehouseId = (selectedWarehouse as any)?.id ?? selectedWarehouse;
  return useCallback(() => invalidateBusinessResources(client,
    { userId, companyId, warehouseId, moduleScope: "commercial" }, mutation),
  [client, userId, companyId, warehouseId, mutation]);
}
